<div>
  <p class="mat-label-large">{{ error.title }}</p>
  <p class="mat-body-small">{{ error.detail }}</p>
</div>

<button mat-icon-button (click)="snackBarRef.dismiss()">
  <mat-icon>close</mat-icon>
</button>
